module.exports = __webpack_public_path__ + "static/media/si_6.acbbb65b.JPG";